import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'appointment-form',
  'create-virtual-visit',
  ['INIT', 'OVERLAP'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'virtual_visits',
    'provider_appointments',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/create-virtual-visit-req.js